import React from 'react';

const RegistrationLoader = ({
    heading,
    subheading,
}) => {
    return (
        <div class=" h-100 d-flex justify-content-center align-items-center">
            <div class="jumbotron text-center">
                <img className='my-4' src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/loaders/RegistrationLoader.gif`} alt="Codelessone" />
                {heading && <h1 class="mb-3">{heading}</h1>}
                {subheading && <h3 className='text-muted lead'>{subheading}</h3>}
            </div>
        </div>
    )
}
export default RegistrationLoader